import type { DemandLevel } from "../types/heatmap"
import { DEMAND_THRESHOLDS } from "../constants/heatmap"

export const DEMAND_LEVEL_COLORS: Record<DemandLevel, string> = {
  low: "bg-[var(--color-brand-200)]",
  medium: "bg-[var(--color-brand-400)]",
  high: "bg-[var(--color-brand-700)]",
  peak: "bg-[var(--color-text-primary)]",
}

export const DEMAND_LEVEL_TEXT_COLORS: Record<DemandLevel, string> = {
  low: "text-[var(--color-text-primary)]",
  medium: "text-[var(--color-text-primary)]",
  high: "text-[var(--color-text-inverse)]",
  peak: "text-[var(--color-text-inverse)]",
}

export function getDemandLevel(value: number): DemandLevel {
  for (const threshold of DEMAND_THRESHOLDS) {
    if (value >= threshold.min && value < threshold.max) {
      return threshold.level
    }
  }
  return "low"
}

export function getCellColorClass(value: number): string {
  const level = getDemandLevel(value)
  return DEMAND_LEVEL_COLORS[level]
}

export function getCellTextColorClass(value: number): string {
  const level = getDemandLevel(value)
  return DEMAND_LEVEL_TEXT_COLORS[level]
}
